import type { definitions } from '@luxuryescapes/contract-svc-lux-loyalty'

type ServerAccountSummary = definitions['accountSummary']

const DISABLED_BENEFIT_CODES = new Set<App.LoyaltyBenefitType>(['hidden_access'])

function mapLoyaltyAccount(response: ServerAccountSummary | null): App.LoyaltyAccount | undefined {
  if (!response) return undefined
  const enabledBenefits = response.benefits.filter(benefit => !DISABLED_BENEFIT_CODES.has(benefit.code))

  return {
    accountNumber: response.accountNumber,
    points: response.points,
    tier: response.tier,
    statusCredits: response.statusCredits,
    ibsMemberId: response.ibsMemberId,
    statusReviewDate: response.statusReviewDate ?? undefined,
    totalCreditsForTierRetention: response.totalCreditsForTierRetention ?? 0,
    totalCreditsForTierUpgrade: response.totalCreditsForTierUpgrade ?? 0,
    numberOfNights: response.numberOfNights ?? 0,
    numberOfNightsForTierUpgrade: response.numberOfNightsForTierUpgrade ?? 0,
    numberOfNightsForTierRetention: response.numberOfNightsForTierRetention ?? 0,
    benefits: enabledBenefits.map((benefit): App.LoyaltyBenefit => ({
      code: benefit.code,
      description: benefit.description,
      remaining: benefit.details.remaining === 'unlimited' ? undefined : benefit.details.remaining,
      limit: benefit.details.limit === 'unlimited' ? undefined : benefit.details.limit,
      unlimited: benefit.details.remaining === 'unlimited' || benefit.details.limit === 'unlimited',
      value: benefit.details.value ? {
        amount: benefit.details.value.amount,
        unit: benefit.details.value.unit,
        currency: benefit.details.value.currency,
      } : undefined,
    })),
    region: response.region,
  }
}

export default mapLoyaltyAccount
